export default "__VITE_ASSET__2653a251__"